// extracted by mini-css-extract-plugin
export default {"input":"SuperBatchModuleInput_input__xiRth"};